// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

class _MainWindowManager 
{
    constructor()
    {
        /**
         * @type { null | import('../panels/Factory.js').Factory }
         * @public
         */
        this.Factory = null;

        /**
         * @type { import('../screen/NewNetTrader.js').NewNetTrader | import('../../Portfolio/PortfolioManagement.js').PortfolioManagement }
         * @public
         */
        this.MainWindow = null;

        /**
         * @type { import('../elements/Lookup/TerceraAccountLookupDropDownForm.js').TerceraAccountLookupDropDownForm | null }
         * @public
         */
        this.TerceraAccountLookupDropDownForm = null;

        /**
         * @type { import('../elements/Lookup/TerceraInstrumentLookupDropDownForm.js').TerceraInstrumentLookupDropDownForm | null }
         * @public
         */
        this.TerceraInstrumentLookupDropDownForm = null;

        /**
         * @type { import('../panels/FullLogsPanel.js').FullLogsPanel | null }
         * @public
         */
        this.FullLogPanel = null;

        /**
         * @type { import('../screen/TerceraChangePasswordScreen.js').TerceraChangePasswordScreen | null }
         * @public
         */
        this.TerceraChangePasswordScreen = null;

        /**
         * @type { import('../screen/TypesManagerScreen.js').TypesManagerScreen | null }
         * @public
         */
        this.TypesManagerScreen = null;

        /**
         * @type { import('../screen/TerceraBrokerMessageScreen.js').TerceraBrokerMessageScreen | null }
         * @public
         */
        this.AsyncCloseObject = null;

        /**
         * @type { import('../panels/AccountDetailsPanel.js').AccountDetailsPanel | null }
         */
        this.AccountDetailsPanel = null;

        this.portfolioWindow = null;
    }
}

export let  MainWindowManager = new _MainWindowManager();